<div class="invoice-preview" [class.dialog-mode]="isDialogMode">
  <div class="preview-shell">
    <div class="preview-header">
      <div class="header-copy">
        <!-- <p class="eyebrow">Goods Receipt Note</p> -->
        <div class="header-title-row">
          <!-- <h2>Store Print Preview</h2> -->
          <div class="toolbar">
            <mat-slide-toggle color="primary" [(ngModel)]="includeSignature">
              Sign + Stamp
            </mat-slide-toggle>
            <button mat-raised-button color="primary" (click)="printPdf()">
              Print
            </button>
            <button mat-stroked-button color="primary" (click)="downloadPdf()">
              Download PDF
            </button>
            <!-- <button mat-flat-button color="accent" (click)="sendMail()">
              Mail Invoice
            </button> -->
            <button
              *ngIf="isDialogMode"
              mat-icon-button
              type="button"
              class="close-preview-button"
              aria-label="Close preview"
              (click)="closePreview()">
              <mat-icon svgIcon="mat:close"></mat-icon>
            </button>
          </div>
        </div>
        <!-- <p class="subtext">
          Professional GRN print with source reference, challan trace, transport details, and receiving summary.
        </p> -->
      </div>
    </div>

    <div class="preview-frame" *ngIf="previewData; else loading">
      <div class="invoice-page">
        <div *ngIf="previewData.logo" class="page-watermark">
          <img [src]="previewData.logo" alt="Company watermark" />
        </div>

        <div class="invoice-top-strip">
          <span></span>
          <span></span>
        </div>

        <div class="invoice-head">
          <div class="logo-cell">
            <img *ngIf="previewData.logo; else logoFallback" [src]="previewData.logo" alt="Company Logo" />
            <ng-template #logoFallback>
              <div class="logo-fallback">{{ previewData.companyInitials }}</div>
            </ng-template>
          </div>

          <div class="company-cell">
            <div class="document-kicker">Store Inward Desk</div>
            <h1>{{ previewData.companyName }}</h1>
            <p *ngIf="previewData.companyAddress">{{ previewData.companyAddress }}</p>
            <p *ngFor="let meta of previewData.companyMeta">{{ meta }}</p>
          </div>

          <div class="invoice-meta-box">
            <div class="meta-badge">GRN DOCUMENT</div>
            <p><strong>GRN Code:</strong> {{ previewData.grnCode }}</p>
            <p><strong>GRN Date:</strong> {{ previewData.grnDate }}</p>
            <p><strong>GRN Type:</strong> {{ previewData.grnTypeLabel }}</p>
            <p *ngIf="previewData.challanNo"><strong>Challan No:</strong> {{ previewData.challanNo }}</p>
          </div>
        </div>

        <div class="overview-grid">
          <div class="overview-card">
            <span class="overview-label">Warehouse</span>
            <strong>{{ previewData.warehouseName || '-' }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">Items</span>
            <strong>{{ previewData.totalItems }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">GRN Qty</span>
            <strong>{{ previewData.totalQty }}</strong>
          </div>
          <div class="overview-card">
            <span class="overview-label">GRN Amount</span>
            <strong>{{ previewData.grnAmount }}</strong>
          </div>
        </div>

        <div class="info-grid">
          <section class="info-card">
            <div class="info-badge">{{ previewData.grnTypeLabel === 'Transfer GRN' ? 'From Branch' : 'Vendor / Party' }}</div>
            <h3>{{ previewData.grnTypeLabel === 'Transfer GRN' ? (previewData.fromBranchName || '-') : (previewData.vendorName || '-') }}</h3>
            <p *ngIf="previewData.partyDocNo"><strong>Party Doc No:</strong> {{ previewData.partyDocNo }}</p>
            <p *ngIf="previewData.partyDocDate !== '-'"><strong>Party Doc Date:</strong> {{ previewData.partyDocDate }}</p>
          </section>

          <section class="info-card">
            <div class="info-badge info-badge--transport">Transport & Challan</div>
            <p *ngIf="previewData.transporterMode"><strong>Mode:</strong> {{ previewData.transporterMode }}</p>
            <p *ngIf="previewData.transporterName"><strong>Transporter:</strong> {{ previewData.transporterName }}</p>
            <p *ngIf="previewData.transporterDocNo"><strong>Transport Doc No:</strong> {{ previewData.transporterDocNo }}</p>
            <p *ngIf="previewData.transporterDocDate !== '-'"><strong>Transport Doc Date:</strong> {{ previewData.transporterDocDate }}</p>
            <p *ngIf="previewData.vehicleNo"><strong>Vehicle No:</strong> {{ previewData.vehicleNo }}</p>
            <p *ngIf="previewData.challanDate !== '-'"><strong>Challan Date:</strong> {{ previewData.challanDate }}</p>
          </section>
        </div>

        <div class="trace-section" *ngIf="previewData.sourceGroups.length > 0">
          <h3>Source Documents</h3>
          <div class="trace-card-grid">
            <div class="trace-card" *ngFor="let group of previewData.sourceGroups">
              <strong>{{ group.code || '-' }}</strong>
              <span>{{ group.date || '-' }}</span>
              <small>Items: {{ group.itemcount || (group.items?.length || 0) }}</small>
            </div>
          </div>
        </div>

        <table class="items-table">
          <thead>
            <tr>
              <th>SR</th>
              <th>SOURCE</th>
              <th>ITEM</th>
              <th>UOM</th>
              <th>CHALLAN</th>
              <th>PENDING</th>
              <th>GRN QTY</th>
              <th>BILL QTY</th>
              <th>RATE</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of previewData.items">
              <td class="center">{{ item.sr }}</td>
              <td class="center">
                <div class="source-code">{{ item.sourceCode || '-' }}</div>
                <div class="source-date">{{ item.sourceDate || '-' }}</div>
              </td>
              <td>
                <div class="item-title">{{ item.productName }}</div>
                <div class="item-sub" *ngIf="item.remarks">{{ item.remarks }}</div>
              </td>
              <td class="center">{{ item.uom }}</td>
              <td class="right">{{ item.challanQty }}</td>
              <td class="right">{{ item.pendingQty }}</td>
              <td class="right strong">{{ item.grnQty }}</td>
              <td class="right">{{ item.billQty }}</td>
              <td class="right">{{ item.rate }}</td>
              <td class="right strong">{{ item.amount }}</td>
            </tr>
          </tbody>
        </table>

        <div class="bottom-grid">
          <div class="details-block">
            <section *ngIf="previewData.remarks !== '-'">
              <h3>Remarks</h3>
              <p>{{ previewData.remarks }}</p>
            </section>
            <section class="words-block">
              <h3>Amount In Words</h3>
              <p>{{ previewData.amountInWords }}</p>
            </section>
          </div>

          <div class="summary-sign-block">
            <div class="summary-card-stack">
              <div class="summary-mini-card">
                <span class="overview-label">Party Doc No</span>
                <strong>{{ previewData.partyDocNo || '-' }}</strong>
              </div>
              <div class="summary-mini-card">
                <span class="overview-label">Vehicle No</span>
                <strong>{{ previewData.vehicleNo || '-' }}</strong>
              </div>
            </div>

            <div class="html-sign-area">
              <div class="sign-company">For {{ previewData.companyName }}</div>
              <div class="sign-assets" *ngIf="includeSignature && (previewData.signatureImage || previewData.stampImage)">
                <img
                  *ngIf="previewData.stampImage"
                  class="stamp-img"
                  [src]="previewData.stampImage"
                  alt="Company Stamp" />
                <img
                  *ngIf="previewData.signatureImage"
                  class="signature-img"
                  [src]="previewData.signatureImage"
                  alt="Authorized Signature" />
              </div>
              <div class="sign-name" *ngIf="previewData.signatoryName">
                {{ previewData.signatoryName }}
              </div>
              <div class="sign-role">
                {{ previewData.signatoryTitle || 'Authorized Signatory' }}
              </div>
            </div>
          </div>
        </div>

        <div class="invoice-footer">
          <div class="footer-line">
            <span></span>
            <span></span>
          </div>
          <div class="footer-text">
            <span>Generated using VCS ERP</span>
            <span>GRN Document</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-state">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      <p class="loading-text">Generating GRN preview...</p>
    </div>
  </ng-template>
</div>
